import React from 'react';
import { Program, ProgramV2 } from 'frontend/types';
import styles from './NotEmbeddableError.module.css';
import NextImage from 'components/NextImage/NextImage';
const NotEmbeddableError = ({
  currentProgram
}: {
  currentProgram: Program | ProgramV2;
}) => <figure className={styles.playerContainer} data-sentry-component="NotEmbeddableError" data-sentry-source-file="NotEmbeddableError.tsx">
    <NextImage className={styles.image} src={currentProgram.image['1280x720']} alt="" width={1280} height={720} data-sentry-element="NextImage" data-sentry-source-file="NotEmbeddableError.tsx" />
    <div className={styles.playerNotAvailable}>
      <div className={styles.notAvailableMessage}>
        <h1 className={styles.messageHeader}>
          Programmet du försökte nå kan tyvärr inte visas
        </h1>
        <p className={styles.message}>Detta kan bero på:</p>
        <ul className={styles.errorCauses}>
          <li className={styles.errorItem}>• Programmet får inte bäddas in</li>
          <li className={styles.errorItem}>
            • Programmets rättigheter har gått ut
          </li>
          <li className={styles.errorItem}>• Inbäddningslänken är felaktig</li>
        </ul>
        <p className={styles.message}>
          Hämta en ny inbäddningslänk eller se programmet på{' '}
          <a className={styles.messageLink} href={`https://www.urplay.se/${currentProgram.id}`}>
            UR Play
          </a>
        </p>
      </div>
    </div>
  </figure>;
export default NotEmbeddableError;